// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

.conversation-list {
    display: flex;
    flex-direction: column;
    width: 28em;
}

.conversation-preview {
  display: flex;
  flex-direction: column;
  width: 100%; /* Ensures the preview takes the full width of the button */
}

.conversation-preview-infos {
  display: flex;
  flex-direction: column;
  /* color: rgb(167, 164, 164); */
  color: rgb(66, 121, 189);
  width: 100%; /* Ensures the infos take the full width of the preview */
}

.conversation-preview-message {
  white-space: nowrap; /* Prevents text from wrapping */
  overflow: hidden; /* Ensures any overflow is hidden */
  text-overflow: ellipsis; /* Adds ellipsis (...) when text overflows */
  width: 100%; /* Ensures the message takes the full width of the infos */
}

.conversation-container {
  display: flex;
  height: calc(100vh - 80px); /* Adjust based on the padding you have set */
  flex-direction: row;
  gap: 2em;
}

.conversation-list, .selected-conversation-container {
  flex: 1 1;
  overflow-y: auto; /* Enables independent scrolling */
  padding: 16px; /* Adjust padding as needed */
}

.conversation-list {
  flex-basis: 30%;
  max-width: 30%;
  overflow-y: auto; /* Enables independent scrolling */
  border-right: 1px solid #ddd; /* Optional: Add a divider between list and details */
  padding: 16px; /* Adjust padding as needed */
}

.selected-conversation-container {
  flex: 1 1; /* Takes the remaining space */
  overflow-y: auto; /* Enables independent scrolling */
  display: flex;
  flex-direction: column;
  gap: 2em;
}

.selected-conversation-infos {
  color: grey;
  font-size: 1em;
  background-color: white;
  border-radius: 1em;
  padding: 1em;
}

.selected-conversation-content {
  display: flex;
  flex-direction: column;
  gap: 1em;
  margin-bottom: 2em;
  background-color: white;
  border-radius: 1em;
  padding: 2em;
}

.chatbot-container {
  float: right;
  color: white;
}

.user-container {
  float: left;
  color: rgb(75, 74, 74);
}

.chatbot-container,
.user-container {
  display: flex;
  flex-direction: column;
}

.chatbot-message {
  float: right;
  background-color: rgb(37, 77, 127);
  color: white;
}

.user-message {
  float: left;
  background-color: rgb(229, 230, 235);
}

.chatbot-message,
.user-message {
  display: flex;
  flex-direction: column;
  gap: 1em;
  border-radius: 1em;
  padding: 1em 2em 1em 2em;
}

.message-container {
    display: flex;
    flex-direction: row;
    gap: 1em;
}

.timestamp {
  color: rgb(184, 183, 183);
  text-align: right;
  padding-right: 2em;
}

.assitant-image {
  float: right;
  border-radius: 5em;
  height: 4em;
  width: 4em;
  margin-left: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/views/admin/conversations/Conversation.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAE,2DAA2D;AAC1E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,wBAAwB;EACxB,WAAW,EAAE,yDAAyD;AACxE;;AAEA;EACE,mBAAmB,EAAE,gCAAgC;EACrD,gBAAgB,EAAE,mCAAmC;EACrD,uBAAuB,EAAE,4CAA4C;EACrE,WAAW,EAAE,0DAA0D;AACzE;;AAEA;EACE,aAAa;EACb,0BAA0B,EAAE,6CAA6C;EACzE,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,gBAAgB,EAAE,kCAAkC;EACpD,aAAa,EAAE,6BAA6B;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB,EAAE,kCAAkC;EACpD,4BAA4B,EAAE,qDAAqD;EACnF,aAAa,EAAE,6BAA6B;AAC9C;;AAEA;EACE,SAAO,EAAE,8BAA8B;EACvC,gBAAgB,EAAE,kCAAkC;EACpD,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["html, body {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\n.conversation-list {\n    display: flex;\n    flex-direction: column;\n    width: 28em;\n}\n\n.conversation-preview {\n  display: flex;\n  flex-direction: column;\n  width: 100%; /* Ensures the preview takes the full width of the button */\n}\n\n.conversation-preview-infos {\n  display: flex;\n  flex-direction: column;\n  /* color: rgb(167, 164, 164); */\n  color: rgb(66, 121, 189);\n  width: 100%; /* Ensures the infos take the full width of the preview */\n}\n\n.conversation-preview-message {\n  white-space: nowrap; /* Prevents text from wrapping */\n  overflow: hidden; /* Ensures any overflow is hidden */\n  text-overflow: ellipsis; /* Adds ellipsis (...) when text overflows */\n  width: 100%; /* Ensures the message takes the full width of the infos */\n}\n\n.conversation-container {\n  display: flex;\n  height: calc(100vh - 80px); /* Adjust based on the padding you have set */\n  flex-direction: row;\n  gap: 2em;\n}\n\n.conversation-list, .selected-conversation-container {\n  flex: 1;\n  overflow-y: auto; /* Enables independent scrolling */\n  padding: 16px; /* Adjust padding as needed */\n}\n\n.conversation-list {\n  flex-basis: 30%;\n  max-width: 30%;\n  overflow-y: auto; /* Enables independent scrolling */\n  border-right: 1px solid #ddd; /* Optional: Add a divider between list and details */\n  padding: 16px; /* Adjust padding as needed */\n}\n\n.selected-conversation-container {\n  flex: 1; /* Takes the remaining space */\n  overflow-y: auto; /* Enables independent scrolling */\n  display: flex;\n  flex-direction: column;\n  gap: 2em;\n}\n\n.selected-conversation-infos {\n  color: grey;\n  font-size: 1em;\n  background-color: white;\n  border-radius: 1em;\n  padding: 1em;\n}\n\n.selected-conversation-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1em;\n  margin-bottom: 2em;\n  background-color: white;\n  border-radius: 1em;\n  padding: 2em;\n}\n\n.chatbot-container {\n  float: right;\n  color: white;\n}\n\n.user-container {\n  float: left;\n  color: rgb(75, 74, 74);\n}\n\n.chatbot-container,\n.user-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.chatbot-message {\n  float: right;\n  background-color: rgb(37, 77, 127);\n  color: white;\n}\n\n.user-message {\n  float: left;\n  background-color: rgb(229, 230, 235);\n}\n\n.chatbot-message,\n.user-message {\n  display: flex;\n  flex-direction: column;\n  gap: 1em;\n  border-radius: 1em;\n  padding: 1em 2em 1em 2em;\n}\n\n.message-container {\n    display: flex;\n    flex-direction: row;\n    gap: 1em;\n}\n\n.timestamp {\n  color: rgb(184, 183, 183);\n  text-align: right;\n  padding-right: 2em;\n}\n\n.assitant-image {\n  float: right;\n  border-radius: 5em;\n  height: 4em;\n  width: 4em;\n  margin-left: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
